<template>
    <div>
        <!-- Quote pricing logo modal -->
        <div class="modal fade" id="pg-quote-pricing-template-logo-modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle"  aria-hidden="true" data-keyboard="false" data-backdrop="static">
            <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title text-black font-normal" id="exampleModalLongTitle">Add/Remove Logos</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body bg-white">
                        <div class="row p-0 m-0">
                            <div class="col-5" v-if="setting.otherLogos.length > 0">
                                <div :class="(logo == selectedLogo)? 'selectedLogoClass hover:border-1 hover:border-teal cursor-pointer':'hover:border-1 hover:border-teal cursor-pointer'" v-for="(logo, index) in setting.otherLogos" :style="'margin-bottom: 10px;float: left;margin-right: 10px; width: 180px; height: 151px;border-radius: 5px;background-size: cover;background-image:url('+logo+');'" @click="selectLogo(logo)">
                                    <span class="qp-logo-delete-icon bg-white" @click="deleteQPLogo(logo, index)"><i class="fa fa-trash-o" aria-hidden="true"></i></span>
                                </div>
                            </div>
                            <div :class="(setting.otherLogos.length > 0)? 'col-7':'col-12'">
                                <image-cropper
                                    :url="uploadUrl"
                                    :image-type="'quoteAndPricingLogo'"
                                    :proposal-template-id="proposalTemplate.id"
                                ></image-cropper>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary" :disabled="!selectedLogo" @click="saveLogoToOBJ">Save</button>
                    </div>
                </div>
            </div>
        </div>
        <!-- Quote pricing logo modal End -->

        <div class="w-100 min-vh-100 border-1 rounded">

            <div class="row p-3 m-0">
                <div class="col-4 p-0">
                    <b-tabs content-class="mt-3">
                        <b-tab title="Settings" active>
                            <div class="row min-vh-100 d-flex align-items-center justify-content-between">
<!--                                <div v-if="selectedSetting == 'company'" class="col-12 d-flex align-items-center text-grey-darkest text-xl">-->
<!--                                    <div class="row p-0 m-0 text-center">-->
<!--                                        <div class="col-12 mb-4 border-b-1 text-left pb-2">Company Information</div>-->
<!--                                        <div class="col-12 text-left">-->
<!--                                            <label class="text-sm">Company Name</label>-->
<!--                                            <input type="text" placeholder="Company Name" class="form-control text-sm" v-model="companyInfo.name" @input="saveSettings('first')">-->

<!--                                            <label class="text-sm mt-2">Address</label>-->
<!--                                            <b-form-textarea-->
<!--                                                id="company-address"-->
<!--                                                size="lg"-->
<!--                                                class="text-sm"-->
<!--                                                placeholder="Company Address"-->
<!--                                                v-model="companyInfo.address"-->
<!--                                                rows="3"-->
<!--                                                @input="saveSettings('first')"-->
<!--                                            ></b-form-textarea>-->

<!--                                            <label class="text-sm mt-2">Phone</label>-->
<!--                                            <input v-model="companyInfo.phone" id="companyPhone" name="companyPhone" maxlength="64"-->
<!--                                                   v-mask="['(###) ###-####', '(###) ###-#### ext. #####']"-->
<!--                                                   placeholder="Company Phone"-->
<!--                                                   class="form-control text-sm"-->
<!--                                                   @input="saveSettings('first')"-->
<!--                                            >-->

<!--                                            <label class="text-sm mt-2">Email</label>-->
<!--                                            <input type="email" placeholder="Company email" class="form-control text-sm" v-model="companyInfo.email" @input="saveSettings('first')">-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                                <div v-else class="col-12 d-flex align-items-center text-grey-darkest text-xl cursor-pointer p-3 rounded-sm hover:bg-grey-lighter" @click="selectSetting('company')">-->
<!--                                    <span class="material-icons text-5xl border-1 rounded-lg bg-teal text-white p-1 mr-3">business</span> Company Info-->
<!--                                </div>-->
                                <div v-if="selectedSetting == 'template'" class="col-12 d-flex align-items-center text-grey-darkest text-xl">
                                    <div class="row p-0 m-0 text-center">
                                        <div class="col-12 mb-4 border-b-1 text-left pb-2">Select Template</div>
                                        <div class="col-4 text-center cursor-pointer" @click="selectTemplate(1)">
                                    <span :class="(setting.template == 1)? 'material-icons text-5xl border-1 rounded-lg bg-teal text-white p-1 text-center hover:bg-teal':'material-icons text-5xl border-1 rounded-lg bg-grey-light text-white p-1 text-center hover:bg-teal'">
                                        article
                                    </span>
                                            <p>Classic</p>
                                        </div>
                                        <div class="col-4 text-center cursor-pointer" @click="selectTemplate(2)">
                                    <span :class="(setting.template == 2)? 'material-icons text-5xl border-1 rounded-lg bg-teal text-white p-1 text-center':'material-icons text-5xl border-1 rounded-lg bg-grey-light text-white p-1 text-center hover:bg-teal'">
                                        feed
                                    </span>
                                            <p>Modern</p>
                                        </div>
                                        <div class="col-4 text-center cursor-pointer" @click="selectTemplate(3)">
                                    <span :class="(setting.template == 3)? 'material-icons text-5xl border-1 rounded-lg bg-teal text-white p-1 text-center':'material-icons text-5xl border-1 rounded-lg bg-grey-light text-white p-1 text-center hover:bg-teal'">
                                        sticky_note_2
                                    </span>
                                            <p>Friendly</p>
                                        </div>
                                    </div>
                                </div>
                                <div v-else class="col-12 d-flex align-items-center text-grey-darkest text-xl cursor-pointer p-3 rounded-sm hover:bg-grey-lighter" @click="selectSetting('template')">
                                    <span class="material-icons text-5xl border-1 rounded-lg bg-teal text-white p-1 mr-3">newspaper</span> Template
                                </div>

                                <div v-if="selectedSetting == 'logo'" class="col-12 d-flex align-items-center text-grey-darkest text-xl cursor-pointer">
                                    <div class="row p-0 m-0 text-center">
                                        <div class="col-12 mb-4 border-b-1 text-left pb-2">Logo Settings</div>
                                        <div class="col-4 text-center p-0">
                                            <div class="row p-0 m-0">
                                                <div class="col-12 p-0 m-0 mb-3">
                                                    <div v-if="setting.logo.url" :style="'height: 100px; width: 120px;background-size: cover;background-image: url('+setting.logo.url+');'" class="border-1 rounded-sm">

                                                    </div>
                                                    <div v-else style="height: 100px; width: 120px;" class="border-1 rounded-sm cursor-pointer d-flex align-items-center text-center" @click="openLogoModal">
                                                        <span class="material-icons w-full" style="font-size: 65px;color: teal;">upload</span>
                                                    </div>
                                                </div>
                                                <div v-if="setting.logo.url" class="col-6 m-0 p-0 text-xs font-weight-bold" @click="openLogoModal">Change Logo</div>
                                                <div v-else class="col-6 m-0 p-0 text-xs font-weight-bold" @click="openLogoModal">Upload Logo</div>
                                                <div class="col-6 m-0 p-0 text-xs text-blue font-weight-bold" v-if="setting.logo.show" @click="showHideLogo('hide')">Hide Logo</div>
                                                <div class="col-6 m-0 p-0 text-xs text-blue font-weight-bold" v-else @click="showHideLogo('show')">Show Logo</div>
                                            </div>
                                        </div>
                                        <div class="col-4 text-center p-0">
                                            <div class="row p-0 m-0">
                                                <div class="col-12 text-left text-sm font-weight-bold mb-3 pl-0">
                                                    Size
                                                </div>
                                                <div style="width: 35px;height: 35px;padding: 4px 0;" :class="(setting.logo.size == 'small')? 'border-1 rounded-full text-base text-center mr-2 border-teal':'border-1 rounded-full text-base text-center mr-2 hover:border-teal'" @click="logoSize('small')">S</div>
                                                <div style="width: 35px;height: 35px;padding: 4px 0;" :class="(setting.logo.size == 'medium')? 'border-1 rounded-full text-base text-center mr-2 border-teal':'border-1 rounded-full text-base text-center mr-2 hover:border-teal'" @click="logoSize('medium')">M</div>
                                                <div style="width: 35px;height: 35px;padding: 4px 0;" :class="(setting.logo.size == 'large')? 'border-1 rounded-full text-base text-center border-teal':'border-1 rounded-full text-base text-center hover:border-teal'" @click="logoSize('large')">L</div>
                                            </div>
                                        </div>
                                        <div class="col-4 text-center p-0">
                                            <div class="row p-0 m-0">
                                                <div class="col-12 text-left text-sm font-weight-bold mb-3 pl-0">
                                                    Placement
                                                </div>
                                                <div style="width: 35px;height: 35px;padding: 5px 0;" :class="(setting.logo.placement == 'left')? 'border-1 rounded-full text-base text-center mr-2 border-teal':'border-1 rounded-full text-base text-center mr-2 hover:border-teal'" @click="logoPlacement('left')"><span class="material-icons">format_align_left</span></div>
                                                <div style="width: 35px;height: 35px;padding: 5px 0;" :class="(setting.logo.placement == 'center')? 'border-1 rounded-full text-base text-center mr-2 border-teal':'border-1 rounded-full text-base text-center mr-2 hover:border-teal'" @click="logoPlacement('center')"><span class="material-icons">format_align_center</span></div>
                                                <div style="width: 35px;height: 35px;padding: 5px 0;" :class="(setting.logo.placement == 'right')? 'border-1 rounded-full text-base text-center border-teal':'border-1 rounded-full text-base text-center hover:border-teal'" @click="logoPlacement('right')"><span class="material-icons">format_align_right</span></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-else class="col-12 d-flex align-items-center text-grey-darkest text-xl cursor-pointer p-3 rounded-sm hover:bg-grey-lighter" @click="selectSetting('logo')">
                                    <span class="material-icons text-5xl border-1 rounded-lg bg-teal text-white p-1 mr-3">image</span> Add/Edit logo
                                </div>

                                <div v-if="selectedSetting == 'color'" class="col-12 d-flex align-items-center text-grey-darkest text-xl cursor-pointer">
                                    <div class="row p-0 m-0 text-center">
                                        <div class="col-12 mb-4 border-b-1 text-left pb-2">Select Colour</div>
                                        <div class="col-3 customSwatchClass pt-3 p-0">
                                            <swatches v-model="setting.color"
                                                      show-fallback
                                                      colors="material-basic"
                                                      row-length="8"
                                                      shapes="circles"
                                                      fallback-input-type="color"
                                                      fallbackOkText="Select"
                                                      fallbackOkClass="bg-followup-nav text-white p-2 rounded font-weight-normal"
                                                      fallbackInputClass="focus:outline-none"
                                            ></swatches>
                                            <input type="text" class="form-control" placeholder="#" v-model="setting.color" @input="selectColor()">
                                        </div>
                                        <div class="col-9">
                                            <swatches
                                                v-model="setting.color"
                                                row-length="6"
                                                shapes="circles"
                                                inline
                                            ></swatches>
                                        </div>
                                    </div>
                                </div>
                                <div v-else class="col-12 d-flex align-items-center text-grey-darkest text-xl cursor-pointer p-3 rounded-sm hover:bg-grey-lighter" @click="selectSetting('color')">
                                    <span class="material-icons text-5xl border-1 rounded-lg bg-teal text-white p-1 mr-3">palette</span> Change colors
                                </div>

                                <div v-if="selectedSetting == 'font'" class="col-12 d-flex align-items-center text-grey-darkest text-xl cursor-pointer">
                                    <div class="row p-0 m-0 text-center">
                                        <div class="col-12 mb-4 border-b-1 text-left pb-2">Font Settings</div>
                                        <div class="col-6">
                                            <p class="text-sm text-left mb-2">Font</p>
                                            <multiselect
                                                v-model="setting.font.style"
                                                :options="googleFonts"
                                                :searchable="true"
                                                :close-on-select="true"
                                                :show-labels="false"
                                                placeholder="Select Font"
                                            ></multiselect>
                                        </div>
                                        <div class="col-6">
                                            <p class="text-sm text-left mb-2">Size</p>
                                            <multiselect
                                                v-model="setting.font.size"
                                                :options="fontSizes"
                                                :searchable="false"
                                                :close-on-select="true"
                                                :show-labels="false"
                                                placeholder="Font Size"
                                            ></multiselect>
                                        </div>
                                    </div>
                                </div>
                                <div v-else class="col-12 d-flex align-items-center text-grey-darkest text-xl cursor-pointer p-3 rounded-sm hover:bg-grey-lighter" @click="selectSetting('font')">
                                    <span class="material-icons text-5xl border-1 rounded-lg bg-teal text-white p-1 mr-3">text_format</span> Change font
                                </div>
                            </div>
                        </b-tab>
                        <b-tab title="Fields">
                            <div class="col-md-12 mt-3" style="height: 95vh; overflow: scroll;">
                                <div class="overflow-hidden">
                                    <div class="text-xl bg-primary border-b-2 border-followup-nav px-3 py-2 text-white mb-3">

                                        <button
                                            class="" style="color:white;">Fields
                                        </button>
                                    </div>
                                    <div @click="toolButton('accountManager', 'Account Manager')" class="field-tooltip col-md-12 tool-buttons inline-block float-left" data-toggle="tooltip" data-placement="top">Account Manager</div>
                                    <div @click="toolButton('baseBid', 'Base Bid')" class="field-tooltip col-md-12 tool-buttons inline-block float-left" data-toggle="tooltip" data-placement="top">Base Bid</div>
                                    <div @click="toolButton('companyAddress', 'Company Address')" class="field-tooltip col-md-12 tool-buttons inline-block float-left" data-toggle="tooltip" data-placement="top">Company Address</div>
                                    <div @click="toolButton('companyCity', 'Company City')" class="field-tooltip col-md-12 tool-buttons inline-block float-left" data-toggle="tooltip" data-placement="top">Company City</div>
                                    <div @click="toolButton('contactCompany', 'Company Name')" class="field-tooltip col-md-12 tool-buttons inline-block float-left" data-toggle="tooltip" data-placement="top">Company Name</div>
                                    <div @click="toolButton('companyNumber', 'Company Number')" class="field-tooltip col-md-12 tool-buttons inline-block float-left" data-toggle="tooltip" data-placement="top">Company Number</div>
                                    <div @click="toolButton('companyState', 'Company State')" class="field-tooltip col-md-12 tool-buttons inline-block float-left" data-toggle="tooltip" data-placement="top">Company State</div>
                                    <div @click="toolButton('companyZip', 'Company Zip')" class="field-tooltip col-md-12 tool-buttons inline-block float-left" data-toggle="tooltip" data-placement="top">Company Zip</div>
                                    <div @click="toolButton('contactEmail', 'Contact Email')" class="field-tooltip col-md-12 tool-buttons inline-block float-left" data-toggle="tooltip" data-placement="top">Contact Email</div>
                                    <div @click="toolButton('addInitials', 'Contact Initials')" class="field-tooltip col-md-12 tool-buttons inline-block float-left" data-toggle="tooltip" data-placement="top">Contact Initials</div>
                                    <div @click="toolButton('contactName', 'Contact Name')" class="field-tooltip col-md-12 tool-buttons inline-block float-left" data-toggle="tooltip" data-placement="top">Contact Name</div>
                                    <div @click="toolButton('contactNumber', 'Contact Number')" class="field-tooltip col-md-12 tool-buttons inline-block float-left" data-toggle="tooltip" data-placement="top">Contact Number</div>
                                    <div @click="toolButton('addSignature', 'Contact Signature')" class="field-tooltip col-md-12 tool-buttons inline-block float-left" data-toggle="tooltip" data-placement="top">Contact Signature</div>
                                    <div @click="toolButton('contactTitle', 'Contact Title')" class="field-tooltip col-md-12 tool-buttons inline-block float-left" data-toggle="tooltip" data-placement="top">Contact Title</div>
                                    <div @click="toolButton('estimator', 'Estimator')" class="field-tooltip col-md-12 tool-buttons inline-block float-left" data-toggle="tooltip" data-placement="top">Estimator</div>
                                    <div @click="toolButton('myEmail', 'My Email')" class="field-tooltip col-md-12 tool-buttons inline-block float-left" data-toggle="tooltip" data-placement="top">My Email</div>
                                    <div @click="toolButton('myName', 'My Name')" class="field-tooltip col-md-12 tool-buttons inline-block float-left" data-toggle="tooltip" data-placement="top">My Name</div>
                                    <div @click="toolButton('myNumber', 'My Number')" class="field-tooltip col-md-12 tool-buttons inline-block float-left" data-toggle="tooltip" data-placement="top">My Number</div>
                                    <div @click="toolButton('mySignature', 'My Signature')" class="field-tooltip col-md-12 tool-buttons inline-block float-left" data-toggle="tooltip" data-placement="top">My Signature</div>
                                    <div @click="toolButton('myTitle', 'My Title')" class="field-tooltip col-md-12 tool-buttons inline-block float-left" data-toggle="tooltip" data-placement="top">My Title</div>
                                    <div @click="toolButton('projectAddress', 'Project Address')" class="field-tooltip col-md-12 tool-buttons inline-block float-left" data-toggle="tooltip" data-placement="top">Project Address</div>
                                    <div @click="toolButton('city', 'Project City')" class="field-tooltip col-md-12 tool-buttons inline-block float-left" data-toggle="tooltip" data-placement="top">Project City</div>
                                    <div @click="toolButton('projectID', 'Project ID')" class="field-tooltip col-md-12 tool-buttons inline-block float-left" data-toggle="tooltip" data-placement="top">Project ID</div>
                                    <div @click="toolButton('projectName', 'Project Name')" class="field-tooltip col-md-12 tool-buttons inline-block float-left" data-toggle="tooltip" data-placement="top">Project Name</div>
                                    <div @click="toolButton('state', 'Project State')" class="field-tooltip col-md-12 tool-buttons inline-block float-left" data-toggle="tooltip" data-placement="top">Project State</div>
                                    <div @click="toolButton('zipCode', 'Project Zip Code')" class="field-tooltip col-md-12 tool-buttons inline-block float-left" data-toggle="tooltip" data-placement="top">Project Zip Code</div>
                                    <div @click="toolButton('addDate', 'Signature Date')" class="field-tooltip col-md-12 tool-buttons inline-block float-left" data-toggle="tooltip" data-placement="top">Signature Date</div>
                                    <div @click="toolButton('state', 'Take Off Person')" class="field-tooltip col-md-12 tool-buttons inline-block float-left" data-toggle="tooltip" data-placement="top">Take off person</div>
                                    <div @click="toolButton('todayDate', 'Todays Date')" class="field-tooltip col-md-12 tool-buttons inline-block float-left" data-toggle="tooltip" data-placement="top">Todays Date</div>
                                </div>
                                <div class="overflow-hidden mt-3">
                                    <div class="text-xl bg-primary border-b-2 border-followup-nav px-3 py-2 text-white mb-3">
                                        <button
                                            class="" style="color:white;">Custom Fields
                                        </button>
                                    </div>
                                    <span v-if="customFieldsLables.length > 0">
                                        <div v-for="customFieldsLable in customFieldsLables" v-if="customFieldsLable.enabled" @click="toolButton(customFieldsLable.label_value.replace(/\s+/g, '-').toLowerCase(), customFieldsLable.name)" class="field-tooltip col-md-12 tool-buttons inline-block float-left">{{ customFieldsLable.name }}</div>
                                    </span>
                                </div>
                                <div class="overflow-hidden mt-3">
                                    <div class="text-xl bg-primary border-b-2 border-followup-nav px-3 py-2 text-white mb-3">
                                        <button
                                                class="" style="color:white;">Dynamic Fields+
                                        </button>
                                    </div>
                                    <span v-if="dynamicFields.length > 0">
                                        <div v-for="dynamicField in dynamicFields"  class="field-tooltip col-md-12 inline-block float-left dynamic-field-div" data-toggle="tooltip" data-placement="top"><span class="text-left col-md-8 m-0 p-0 dynamic-field-name" @click="toolButtonDynamicFields(dynamicField.name.replace(/\s+/g, '-').toLowerCase(), dynamicField.code)">{{ dynamicField.name }}</span></div>
                                    </span>
                                </div>
                            </div>
                        </b-tab>

                    </b-tabs>

                </div>
                <div class="col-8" >
                    <div class="row min-vh-100 d-flex align-items-center justify-content-between">
                        <div class="col-12">
                            <div style="width: 712px;height: 1100px;" class="border-1 m-auto rounded-sm my-2">
                                <classic-quote-pricing-template
                                    v-show="setting.template == 1"
                                    :template-setting="setting"
                                    :sectionData="sectionData"
                                    class="quotePricingTemplateShow"
                                    ref="QuotePricingTemplateShowRef1"
                                ></classic-quote-pricing-template>
                                <modern-quote-pricing-template
                                    v-show="setting.template == 2"
                                    :template-setting="setting"
                                    :sectionData="sectionData"
                                    class="quotePricingTemplateShow"
                                    ref="QuotePricingTemplateShowRef2"
                                ></modern-quote-pricing-template>
                                <friendly-quote-pricing-template
                                    v-show="setting.template == 3"
                                    :template-setting="setting"
                                    :sectionData="sectionData"
                                    class="quotePricingTemplateShow"
                                    ref="QuotePricingTemplateShowRef3"
                                ></friendly-quote-pricing-template>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="text-right mb-3 mr-4">
                <button class="btn btn-outline-primary rounded-full mr-2" @click="generateReview()">Preview PDF</button>
                <button class="btn btn-primary rounded-full mr-2" @click="saveSettings()">Save</button>
            </div>
        </div>

        <div class="quote-price-template-review-loader">
            <img src="/images/proposal-loader.gif" />
            <h1 class="align-center">Generating preview, please wait.</h1>
        </div>
    </div>
</template>

<script>
import Swatches from 'vue-swatches';
import Multiselect from "vue-multiselect";
import ImageCropper from "../../../shared/image-cropper.vue";
import ClassicQuotePricingTemplate from "./template/classic-quote-pricing-template.vue";
import ModernQuotePricingTemplate from "./template/modern-quote-pricing-template.vue";
import FriendlyQuotePricingTemplate from "./template/friendly-quote-pricing-template.vue";
import axios from "axios";
export default {
    name: "pg-quote-pricing-template-setting",
    props:['proposalTemplate', 'baseUrl'],
    components: {
        FriendlyQuotePricingTemplate,
        ModernQuotePricingTemplate, ClassicQuotePricingTemplate, ImageCropper, Multiselect, Swatches},
    data() {
        return {
            selectedSetting: null,
            setting: {
                template: 1,
                logo: {
                    url: null,
                    size: 'small',
                    placement: 'right',
                    show: true
                },
                color: '#38b2b0',
                font: {
                    style: null,
                    size: '14px'
                },
                otherLogos: [],
                sectionData:null,
            },
            swatchStyle: {
                width: '90px',
                height: '90px'
            },
            googleFonts: [],
            fontSizes: [
                '8px',
                '10px',
                '12px',
                '14px',
                '16px',
                '18px',
                '20px',
            ],
            uploadUrl: this.baseUrl+'/api/proposal-settings/quote-pricing-template/upload-logo',
            selectedLogo: null,
            senderAddress:'',
            companyInfo: {
                name: null,
                address: null,
                phone: null,
                email: null
            },
            labelsReorder: [],
            customLabelsReorder: [],
            dynamicFields: [],
            fieldData: {
                isRequired: true,
                selectedType: { name: null},
                name: '',
                label: '',
                title: '',
                options: [
                    {
                        name: '',
                        required: false
                    },
                    {
                        name: '',
                        required: false
                    }
                ]
            },
            customFieldsLables: [],
            sectionData: {
                projectData: null,
                companyData: null,
                salesRepData: null,
                signatureData: null,
            },
        }
    },
    mounted(){
        if(this.proposalTemplate.decoded_setting){
            console.log('hererere');
            this.setting = this.proposalTemplate.decoded_setting;
            this.companyInfo = (this.proposalTemplate.decoded_company_info)? this.proposalTemplate.decoded_company_info:{
                name: null,
                address: null,
                phone: null,
                email: null
            };

            if(this.proposalTemplate.decoded_setting.hasOwnProperty('sectionData')){
                this.sectionData = this.proposalTemplate.decoded_setting.sectionData
            }
        }else{
            this.saveSettings('first');
        }
        this.fetchSettings();
        this.getAllGoogleFonts();
        this.fetchProjectCustomFields();
        this.getDynamicFields();
    },
    methods: {
        selectSetting(settingItem){
            this.selectedSetting = settingItem;
        },
        selectTemplate(selectedTemplate){
            this.setting.template = selectedTemplate;
        },
        showHideLogo(visible){
            this.setting.logo.show = (visible === 'show');
        },
        logoSize(size){
            this.setting.logo.size = size;
        },
        logoPlacement(placement){
            this.setting.logo.placement = placement;
        },
        selectColor(){
            this.setting.color = this.setting.color.replace(/##/g, '#');
        },
        getAllGoogleFonts(){
            axios.post(route('api.proposal-settings.quote-pricing-template.get-all-google-fonts')).then(response => {
                this.googleFonts = response.data.fonts;
            })
        },
        saveSettings(from = null){
            this.$nextTick(() => {
                axios.post(route('api.proposal-settings.quote-pricing-template.save-settings'), {templateId: this.proposalTemplate.id, setting: this.setting, companyInfo: this.companyInfo}).then(response => {
                    if(from !== 'first'){
                        this.getToast().fire({
                            type: 'success',
                            title: 'Quote & pricing template setting saved'
                        });
                    }
                });
            });
        },
        openLogoModal(){
            this.selectedLogo = null;
            $('#pg-quote-pricing-template-logo-modal').modal('show');
        },
        fetchSettings(){
            axios.post(route('api.proposal-settings.quote-pricing-template.get-settings'), {templateId: this.proposalTemplate.id}).then(response => {
                this.setting.otherLogos = response.data.setting.otherLogos;
                this.companyInfo = (response.data.companyInfo)? response.data.companyInfo:{
                    name: null,
                    address: null,
                    phone: null,
                    email: null
                };
            });
        },
        selectLogo(logo){
            this.selectedLogo = logo;
        },
        saveLogoToOBJ(){
            this.setting.logo.url = this.selectedLogo;
            $('#pg-quote-pricing-template-logo-modal').modal('hide');
        },
        deleteQPLogo(logo, index){
            if (index > -1 && index < this.setting.otherLogos.length && this.setting.otherLogos.length > 0) {
                this.setting.otherLogos.splice(index, 1);
            }
        },
        generateReview(){
            this.saveSettings('first');
            $('.quote-price-template-review-loader').show();
            axios.post(route('api.proposal-settings.quote-pricing-template.generate-review'), {templateId: this.proposalTemplate.id}).then(response => {
               this.checkReview();
            });
        },
        checkReview(){
            axios.post(route('api.proposal-settings.quote-pricing-template.check-review'), {templateId: this.proposalTemplate.id}).then(response => {
                if(response.data.status == 'success'){
                    $('.quote-price-template-review-loader').hide();
                    let newWindow = window.open(response.data.templateUrl,'_blank');
                    if (window.focus) {
                        newWindow.focus()
                    }
                }else{
                    setTimeout(() => {
                        this.checkReview();
                    },2000);
                }
            });
        },
        fetchProjectCustomFields(){
            this.labelsReorder = [];
            this.customLabelsReorder = [];
            axios.get(route('api.project-custom-field.index'))
                .then((response) => {
                    this.customFieldsLables = [];
                    this.customFieldsLables = response.data.data.sort((a,b) => a.label_order - b.label_order);
                });
        },
        getDynamicFields(){
            axios.post(route('proposal-generator.get-dynamic-field'), {data: this.fieldData}).then(response => {
                console.log(response);
                this.dynamicFields = response.data.dynamicFields
            });
        },
        toolButton(button, content){
            let field = '{{'+content+'}}';
            Bus.$emit('pgQuoteSettingField', field);
        },
        toolButtonDynamicFields(button, text){
            let content = { type: 'text', content: text.replace(/\\n/g, "\n")};
            Bus.$emit('pgQuoteSettingField', content.content);
        },
        contentAdded(data){
            this.setting.sectionData = data;
            // this.$nextTick(() => {
            //    this.saveSettings('first');
            // });
        },
        addMention(){

        }
    },
    watch: {
        'setting': {
            handler(newValue, oldValue) {
                this.$nextTick(() => {
                    Bus.$emit('valueUpdatedQBTemplates', newValue)
                });
            },
            deep: true
        }
    }
};
</script>
<style>
.customSwatchClass .vue-swatches__trigger {
    width: 70px !important;
    height: 70px !important;
}
.quotePricingTemplateShow {
    transform: scale(.55);
    -webkit-transform: scale(.84);
    -webkit-transform-origin: 0 0;
    width: 119% !important;
    height: 119%;
}
.selectedLogoClass{
    box-shadow: 0px 0px 5px 3px teal;
}
.qp-logo-delete-icon{
    border-radius: 100px;
    padding: 2px 6px;
    color: red;
    position: relative;
    top: -7px;
    left: -8px;
    border: 1px solid teal;
}

.quote-price-template-review-loader{
    position: fixed;
    display: none;
    width: 100%;
    height: 100%;
    top:18px;
    left: 0;
    right: 0;
    bottom: 0;
    //background-color: rgba(0,0,0,0.5);
    z-index: 999;
    cursor: pointer;
    background: #ffffffd9;
}
.quote-price-template-review-loader img{
    position: absolute;
    right: 42%;
    top: 28%;
}
.quote-price-template-review-loader h1{
    position: absolute;
    color: #01b1af;
    top: 60%;
    right: 36vw;
    font-weight: 200;
}
</style>
